function e(t) {
  return ["top", "bottom"].indexOf(t) >= 0 ? "x" : "y";
}
export {
  e as default
};
//# sourceMappingURL=getMainAxisFromPlacement.mjs.map
